import script from "./IAcquirings.vue?vue&type=script&setup=true&lang=js"
export * from "./IAcquirings.vue?vue&type=script&setup=true&lang=js"

import "./IAcquirings.vue?vue&type=style&index=0&id=66bdbddc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bdbddc"]])

export default __exports__